import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
  },
  viewDetails: {
    paddingRight: '0px !important',
    selectors: {
      '&:focus': {
        outline: 'thin !important',
      },
    },
  },
  bulletedList: {
    paddingRight: pxToRem(10),
  },
  exportToExcel: {
    marginBottom: pxToRem(50),
  },
  nameSection: {
    marginTop: pxToRem(20),
    marginBottom: pxToRem(40),
  },
  panelHeader: {
    selectors: {
      '& .ms-Panel-commands': {
        marginTop: pxToRem(32),
      },
      '& .ms-Panel-header': {
        paddingBottom: pxToRem(16),
      },
      '& .ms-Panel-headerText': {
        paddingBottom: pxToRem(10),
        borderBottom: `${pxToRem(2)} solid ${theme.palette.neutralTertiaryAlt}`,
      },
    },
  },
  excludeButton: {
    background: 'transparent',
    width: '90%',
  },
  filterDimensionLink: {
    textDecoration: 'none',
  },
});
